// 页面装修数据
import dayjs from 'dayjs';

const decorate = {
  state: {
    // 编辑中的数据
    editDecorate: '',

    // 媒体组件数据
    mediaDecorate: [
      // 搜索框
      {
        title: '搜索框',
        isMini: true,
        icon: 'icon-minsu_zaoniao',
        data: {
          name: 'Search',
          title: '搜索框',
          option: {
            bgc: '#ffffff', //搜索框背景颜色
            placeholder: '请输入', //占位文字内容
            url: '', //系统链接
            link: '', //自定义链接
            appUrl: '', //小程序链接
            appid: '', //小程序appid
            urlType: 2, //链接类型
            shape: 'round', //搜索框形状，round-圆形，square-方形
            inputAlign: 'left', //输入框内容水平对齐方式
          },
        },
      },
      // 导航组
      {
        title: '导航组',
        isMini: true,
        icon: 'icon-minsu_zaoniao',
        data: {
          name: 'ButtonGroup',
          title: '导航组',
          option: {
            bgc: '#ffffff',
            num: 4,
            iconSize: 90,
            textMargin: 10,
            textSize: 26,
            iconBorderRadius: 50,
            list: [
              {
                image: '',
                type: 1,
                icon: '',
                iconColor: '#0094ff',
                text: '按钮文本',
                color: '#000000',
                url: '', //系统链接
                link: '', //自定义链接
                appUrl: '', //小程序链接
                appid: '', //小程序appid
                urlType: 2, //链接类型
              },
              {
                image: '',
                type: 1,
                icon: '',
                iconColor: '#0094ff',
                text: '按钮文本',
                color: '#000000',
                url: '', //系统链接
                link: '', //自定义链接
                appUrl: '', //小程序链接
                appid: '', //小程序appid
                urlType: 2, //链接类型
              },
              {
                image: '',
                type: 1,
                icon: '',
                iconColor: '#0094ff',
                text: '按钮文本',
                color: '#000000',
                url: '', //系统链接
                link: '', //自定义链接
                appUrl: '', //小程序链接
                appid: '', //小程序appid
                urlType: 2, //链接类型
              },
              {
                image: '',
                type: 1,
                icon: '',
                iconColor: '#0094ff',
                text: '按钮文本',
                color: '#000000',
                url: '', //系统链接
                link: '', //自定义链接
                appUrl: '', //小程序链接
                appid: '', //小程序appid
                urlType: 2, //链接类型
              },
            ], //列表
            topBomPad: 0, //上下边距
          },
        },
      },
      // 图片轮播
      {
        title: '图片轮播',
        isMini: true,
        icon: 'icon-minsu_zaoniao',
        data: {
          name: 'Swiper',
          title: '图片轮播',
          option: {
            height: 300, //轮播图高度
            list: [
              {
                image: '',
                url: '', //系统链接
                link: '', //自定义链接
                appUrl: '', //小程序链接
                appid: '', //小程序appid
                urlType: 2, //链接类型
              },
            ], //轮播图列表
            autoplay: true, //自动播放
            mode: 'dot',
            indicatorPos: 'bottomCenter', //指示器的位置
            effect3d: false, //是否开启3D效果
            duration: 500, //切换一张轮播图所需的时间，单位ms
            interval: 2500, //自动轮播时间间隔，单位ms
            borderRadius: 0, //圆角值
          },
        },
      },
      // 单图组
      {
        title: '图片广告',
        isMini: true,
        icon: 'icon-minsu_zaoniao',
        data: {
          name: 'OneImage',
          title: '图片广告',
          option: {
            height: 500, //图片高度
            list: [
              {
                image: '',
                url: '', //系统链接
                link: '', //自定义链接
                appUrl: '', //小程序链接
                appid: '', //小程序appid
                urlType: 2, //链接类型
              },
            ], //单图列表
            topBomPad: 0, //上下边距
            LefRigPad: 0, //左右边距
          },
        },
      },
      // 图片橱窗
      {
        title: '图片橱窗',
        isMini: true,
        icon: 'icon-minsu_zaoniao',
        data: {
          name: 'ManyImage',
          title: '图片橱窗',
          option: {
            topBomPad: 0, //上下边距
            LefRigPad: 0, //左右边距
            flexType: 2, //布局方式
            bgc: '#ffffff', //背景颜色
            height: 300,
            list: [
              {
                image: '',
                url: '', //系统链接
                link: '', //自定义链接
                appUrl: '', //小程序链接
                appid: '', //小程序appid
                urlType: 2, //链接类型
              },
              {
                image: '',
                url: '', //系统链接
                link: '', //自定义链接
                appUrl: '', //小程序链接
                appid: '', //小程序appid
                urlType: 2, //链接类型
              },
            ], //列表
          },
        },
      },
      // 广告
      {
        title: '公告',
        isMini: true,
        icon: 'icon-minsu_zaoniao',
        data: {
          name: 'NoticeBar',
          title: '公告',
          option: {
            topBomPad: 0, //上下边距
            image: 'https://pms-dev001.oss-cn-shenzhen.aliyuncs.com/saas/1/shop/goods/20220524/ddb3425b96e5f3d3410cb511ec48426a.png', //图片
            playState: 'play', //是否自动播放
            bgc: '#ffffff', //背景颜色
            duration: 2000, //滚动周期时长
            color: '#000000', //字体颜色
            type: 1,
            icon: '',
            iconColor: '#0094ff',
            list: [
              {
                text: '这是文本',
                url: '', //系统链接
                link: '', //自定义链接
                appUrl: '', //小程序链接
                appid: '', //小程序appid
                urlType: 2, //链接类型
              },
            ],
            text: ['这是文本'], //文本
          },
        },
      },
      // 视频
      {
        title: '视频',
        isMini: true,
        icon: 'icon-minsu_zaoniao',
        data: {
          name: 'Video',
          title: '视频',
          option: {
            height: 300, //高度
            topBomPad: 0, //上下边距
            LefRigPad: 0, //左右边距
            url: '', //播放视频的资源地址
            autoplay: true, //自动播放
            poster: '', //视频封面
          },
        },
      },
      // 弹窗广告
      {
        title: '弹窗广告',
        isMini: false,
        icon: 'icon-minsu_zaoniao',
        max: 1,
        data: {
          name: 'Popup',
          title: '弹窗广告',
          option: {
            mode: 'center',
            mask: true,
            maskClose: false,
            height: 300, //图片高度
            LefRigPad: 150, //左右边距
            indate: [dayjs().valueOf(), dayjs().add(3, 'day').valueOf()], //弹窗有效期
            interval: 60, //弹窗间隔（分钟）
            image: '', //图片
            url: '', //系统链接
            link: '', //自定义链接
            appUrl: '', //小程序链接
            appid: '', //小程序appid
            urlType: 2, //链接类型
          },
        },
      },
    ],

    // 工具组件数据
    toolDecorate: [
      // 辅助空白
      {
        title: '辅助空白',
        isMini: true,
        icon: 'icon-minsu_zaoniao',
        data: {
          name: 'Blank',
          title: '辅助空白',
          option: {
            height: 20, //高度
            bgc: '#ffffff', //背景颜色
          },
        },
      },
      // 富文本
      {
        title: '富文本',
        isMini: true,
        icon: 'icon-minsu_zaoniao',
        data: {
          name: 'RichText',
          title: '富文本',
          option: {
            topBomPad: 0, //上下边距
            LefRigPad: 0, //左右边距
            bgc: '#ffffff', //背景颜色
            richText: '这里是文本的内容', //富文本
          },
        },
      },
      // 分割线
      {
        title: '线条',
        isMini: true,
        icon: 'icon-minsu_zaoniao',
        data: {
          name: 'Subline',
          title: '线条',
          option: {
            topBomPad: 20, //上下边距
            LefRigPad: 20, //左右边距
            color: '#000000', //线条颜色
            bgc: '#ffffff', //背景颜色
            lineHeight: 2, //线条宽度
            lineType: 'solid', //线条样式
          },
        },
      },
    ],

    // 个人中心组件数据
    userDecorate: [
      // 信息栏
      {
        title: '用户信息',
        isMini: true,
        icon: 'icon-minsu_zaoniao',
        max: 1,
        data: {
          name: 'MineInfo',
          title: '用户信息',
          option: {
            topBomPad: 0, //上下边距
            LefRigPad: 0, //左右边距
            height: 200, //高度
            inLefRigPad: 20, //内边距
            margin: 20, //间距
            bgc: '#00aaff', //背景颜色
            borderRadius: 0, //圆角值
            imageSize: 80, //头像大小
            iconSize: 40, //图标大小
            iconColor: '#ffffff', //图标大小
            color: '#ffffff', //文字颜色
            conColor: '#f2f2f2',
            fontSize: 28,
            conFontSize: 24,
            image: '', //背景图片
            type: 1, //样式 1 左右分布 2 居中分布
            showType: [],
          },
        },
      },
      // 导航栏
      {
        title: '导航栏',
        isMini: true,
        icon: 'icon-minsu_zaoniao',
        data: {
          name: 'ButtonRow',
          title: '导航栏',
          option: {
            topBomPad: 0, //上下边距
            LefRigPad: 0, //左右边距
            height: 100, //高度
            inLefRigPad: 30, //内边距
            textMarginLef: 30, //文本左边距
            bgc: '#ffffff', //背景颜色
            borderRadius: 0, //圆角值
            borderColor: '#ffffff', //边框颜色
            iconSize: 40, //图标大小
            arrowSize: 30, //箭头大小
            arrowColor: '#0094ff', //箭头颜色
            showIcon: true, //展示图标
            list: [
              {
                image: '',
                type: 1,
                icon: '',
                iconColor: '#0094ff',
                text: '按钮文本',
                color: '#000000',
                borderColor: '#f2f2f2', //下边框颜色
                url: '', //系统链接
                link: '', //自定义链接
                appUrl: '', //小程序链接
                appid: '', //小程序appid
                urlType: 2, //链接类型
              },
              {
                image: '',
                type: 1,
                icon: '',
                iconColor: '#0094ff',
                text: '按钮文本',
                color: '#000000',
                borderColor: '#f2f2f2', //下边框颜色
                url: '', //系统链接
                link: '', //自定义链接
                appUrl: '', //小程序链接
                appid: '', //小程序appid
                urlType: 2, //链接类型
              },
            ], //列表
          },
        },
      },
      // 数据统计
      {
        title: '数据统计',
        isMini: true,
        icon: 'icon-minsu_zaoniao',
        data: {
          name: 'DataCount',
          title: '数据统计',
          option: {
            topBomPad: 0, //上下边距
            lefRigPad: 0, //左右边距
            borderRadius: 0, //圆角值
            height: 120, //高度
            bgc: '#ffffff', //背景颜色
            textMargin: 16, //上下间隔
            textSize: 28, //文字大小
            numSize: 30, //数字大小
            color: '#000000', //文字颜色
            list: [
              {
                text: '文本内容',
                num: 99,
                dataFrom: '', //数据来源
                url: '', //系统链接
                numColor: '#da0000', //数字颜色
              },
              {
                text: '文本内容',
                num: 99,
                dataFrom: '', //数据来源
                url: '', //系统链接
                numColor: '#da0000', //数字颜色
              },
            ], //列表
          },
        },
      },
      // 我的订单
      {
        title: '我的订单',
        isMini: true,
        icon: 'icon-minsu_zaoniao',
        max: 1,
        data: {
          name: 'OrderGroup',
          title: '我的订单',
          option: {
            source: 'msUserOrder', //数据来源
            topBomPad: 20, //上下边距
            lefRigPad: 0, //左右边距
            bgc: '#ffffff', //背景颜色
            titleColor: '#000000', //标题颜色
            btnColor: '#999999', //按钮颜色
            iconSize: 80, //图标大小
            iconBorderRadius: 50, //图标圆角值
            textMargin: 20, //上下边距
            textSize: 28, //文字大小
            topRadius: 0, //上圆角值
            bomRadius: 0, //下圆角值
            marginBom: 0, //上下间隔
            position: 0, // 是否定位
            top: 0, // 定位值
            url: '', //系统链接
            link: '', //自定义链接
            appUrl: '', //小程序链接
            appid: '', //小程序appid
            urlType: 2, //链接类型
            list: [], //列表
          },
        },
      },
      // 单按钮
      {
        title: '单按钮',
        isMini: true,
        icon: 'icon-minsu_zaoniao',
        data: {
          name: 'OneButton',
          title: '单按钮',
          option: {
            height: 100, //高度
            topBomPad: 30, //上下边距
            lefRigPad: 30, //左右边距
            bgc: '#00aaff', //背景颜色
            radius: 20, //圆角值
            borderColor: '#f2f2f2', //边框颜色
            color: '#ffffff', //文字颜色
            textSize: 28, //文字大小
            text: '按钮文本', //文字
            url: '', //系统链接
            link: '', //自定义链接
            urlType: 2, //链接类型
          },
        },
      },
    ],

    // 民宿组件数据
    msDecorate: [
      // 民宿搜索
      {
        title: '民宿搜索',
        isMini: true,
        icon: 'icon-minsu_zaoniao',
        max: 1,
        data: {
          name: 'SearchBox',
          title: '民宿搜索',
          option: {
            type: 1, //1 民宿
            topBomMar: 30, //上下外边距
            LefRigMar: 30, //左右外边距
            topBomPad: 30, //上下边距
            LefRigPad: 30, //左右边距
            borderRadius: 40, //圆角值
            height: 300, //高度
            bgc: '#ffffff', //背景颜色
            color1: '#000000', //主要字体颜色
            color2: '#999999', //次要字体颜色
            position: 0, // 是否定位
            top: 0, // 定位值
            placeholder: '景点/位置/关键词', //输入框提示
            btnTopBomMar: 0, //按钮上下边距
            btnLefRigMar: 0, //按钮左右边距
            btnHeight: 80, //按钮高度
            btnColor: '#0094ff', //按钮颜色
            btnText: '搜索',
            btnTextColor: '#fff', //按钮字体颜色
            btnTextSize: '28', //按钮字体大小
            btnBorderRadius: '20', //按钮圆角值
          },
        },
      },
      // 民宿列表
      {
        title: '民宿列表',
        isMini: true,
        icon: 'icon-minsu_zaoniao',
        data: {
          name: 'MsRoomList',
          title: '民宿列表',
          option: {
            source: 1, // 1 自动获取 2 手动获取
            flexType: 2, //1 单列 2 两列 3 轮播
            bgc: '#ffffff', //背景颜色
            num: 6, //显示数量
            sort: 1, // 1 综合 2销量高到低 3销量低到高 4价格高到低 5价格低到高
            space_ids: [],
            recom_id: [],
            showType: ['sales', 'comment'], //显示内容 sales 已售 comment 评论数
            autoplay: false, //自动播放
            duration: 500, //切换一张轮播图所需的时间，单位ms
            interval: 2500, //自动轮播时间间隔，单位ms
            swiperRadius: 20, //轮播图圆角
            swiperMargin: 200, //轮播图边距
            swiperHeigth: 500, //轮播图高度
            list: [
              {
                showRoom: false,
                cover: '',
                title: '此处为显示民宿名称',
                arr_price: {
                  price: 99,
                },
                cstatus: 5,
                house_type_text: '1室1厅',
                facility: ['休闲胜地', '可聚餐', '可做饭'],
              },
              {
                showRoom: false,
                cover: '',
                title: '此处为显示民宿名称',
                arr_price: {
                  price: 99,
                },
                cstatus: 5,
                house_type_text: '1室1厅',
                facility: ['休闲胜地', '可聚餐', '可做饭'],
              },
              {
                showRoom: false,
                cover: '',
                title: '此处为显示民宿名称',
                arr_price: {
                  price: 99,
                },
                cstatus: 5,
                house_type_text: '1室1厅',
                facility: ['休闲胜地', '可聚餐', '可做饭'],
              },
              {
                showRoom: false,
                cover: '',
                title: '此处为显示民宿名称',
                arr_price: {
                  price: 99,
                },
                cstatus: 5,
                house_type_text: '1室1厅',
                facility: ['休闲胜地', '可聚餐', '可做饭'],
              },
            ], //商品列表
          },
        },
      },
    ],

    // 个人中心我的订单组件数据
    orderSource: [
      {
        value: 'msUserOrder',
        label: '民宿用户',
        url: 'pages/ms/order/order',
        option: [
          {
            text: '待支付',
            url: 'pages/ms/order/order?isSelTab=2',
            show: true,
          },
          {
            text: '进行中',
            url: 'pages/ms/order/order?isSelTab=3',
            show: true,
          },
          {
            text: '待点评',
            url: 'pages/ms/comment/list',
            show: true,
          },
          {
            text: '售后',
            url: 'pages/ms/order/afterSale',
            show: true,
          },
        ],
      },
      {
        value: 'msLandlordOrder',
        label: '民宿房东',
        url: 'pages/ms/landlord/orderCenter/index',
        option: [
          {
            text: '待确认',
            url: 'pages/ms/landlord/orderCenter/index?isSelTab=2',
          },
          {
            text: '待入住',
            url: 'pages/ms/landlord/orderCenter/index?isSelTab=3',
          },
          {
            text: '入住中',
            url: 'pages/ms/landlord/orderCenter/index?isSelTab=4',
          },
          {
            text: '已取消',
            url: 'pages/ms/landlord/orderCenter/index?isSelTab=5',
          },
          {
            text: '已完成',
            url: 'pages/ms/landlord/orderCenter/index?isSelTab=6',
          },
          {
            text: '已失效',
            url: 'pages/ms/landlord/orderCenter/index?isSelTab=7',
          },
          {
            text: '点评管理',
            url: 'pages/ms/landlord/commentManage/list',
          },
        ],
      },
    ],

    // 个人中心我的订单组件数据_小程序
    orderSourceMini: [
      {
        value: 'msUserOrder',
        label: '民宿用户',
        url: 'pages/ms/order/order',
        option: [
          {
            text: '待支付',
            url: '/pages/order/list/index?tab=1',
            show: true,
          },
          {
            text: '进行中',
            url: '/pages/order/list/index?tab=2',
            show: true,
          },
          {
            text: '待点评',
            url: '/pages/comment/list/index',
            show: true,
          },
          {
            text: '售后',
            url: '/pages/order/afterSale/index',
            show: true,
          },
        ],
      },
    ],

    // 个人中心数据统计组件数据
    centreData: [
      {
        label: '云平台',
        key: 'shopCollect',
        children: [
          {
            label: '钱包余额',
            key: 'balance',
            url: 'pages/cloud/user/wallet/wallet',
          },
          {
            label: '累计收入',
            key: 'income',
            url: 'pages/cloud/user/wallet/wallet',
          },
        ],
      },
      {
        label: '民宿用户',
        key: 'msCollect',
        children: [
          {
            label: '收藏量',
            key: 'msCollect',
            url: 'pages/ms/collect/collect',
          },
          {
            label: '浏览量',
            key: 'msBrowse',
            url: 'pages/ms/history/history',
          },
        ],
      },
      {
        label: '民宿商家',
        key: 'msLTOCount',
        children: [
          {
            label: '今日订单数量',
            key: 'msLTOCount',
            url: '/pages/ms/landlord/orderCenter/index',
          },
          {
            label: '今日订单额',
            key: 'msLTOAmount',
            url: '',
          },
          {
            label: '本月订单数',
            key: 'msLMOCount',
            url: '/pages/ms/landlord/orderCenter/index',
          },
          {
            label: '本月订单额',
            key: 'msLMOAmount',
            url: '',
          },
          {
            label: '本月入住率',
            key: 'msLMCheckInRate',
            url: '',
          },
          {
            label: '本月结算累计',
            key: 'msLMSettleAmount',
            url: '',
          },
          {
            label: '本月结算待打款',
            key: 'msLMSettleUnPay',
            url: '',
          },
          {
            label: '本月结算已打款',
            key: 'msLMSettlePayed',
            url: '',
          },
          {
            label: '累计未打款',
            key: 'msLMSettleUnPay',
            url: '',
          },
        ],
      },
      {
        label: 'PMS房东',
        key: 'pmsTodayOrder',
        children: [
          {
            label: '今日订单',
            key: 'pmsTodayOrder',
            url: 'pages/PMS/order/order',
          },
          {
            label: '待入住',
            key: 'pmsUnCheckedin',
            url: 'pages/PMS/order/order?tab=9',
          },
          {
            label: '待退房',
            key: 'pmsCheckedOut',
            url: 'pages/PMS/order/order?tab=10',
          },
          {
            label: '入住中',
            key: 'pmsCheckedin',
            url: 'pages/PMS/order/order?tab=4',
          },
          {
            label: '空房',
            key: 'pmsTodayUnSela',
            url: '',
          },
        ],
      },
    ],
  },

  getters: {
    // 返回民宿组件数据
    getMsDecorate(state) {
      return state.msDecorate;
    },

    // 返回数据统计组件数据
    getCentreData(state) {
      return state.centreData;
    },

    // 返回订单组件数据来源_小程序
    getOrderSourceMini(state) {
      return state.orderSourceMini;
    },

    // 返回订单组件数据来源
    getOrderSource(state) {
      return state.orderSource;
    },

    // 返回媒体装修数据
    getUserDecorate(state) {
      return state.userDecorate;
    },

    // 返回媒体装修数据
    getWorkDecorate(state) {
      return state.workDecorate;
    },

    // 返回媒体装修数据
    getMediaDecorate(state) {
      return state.mediaDecorate;
    },

    // 返回工具装修数据
    getToolDecorate(state) {
      return state.toolDecorate;
    },

    // 返回编辑中的数据
    getEditDecorate(state) {
      return state.editDecorate;
    },
  },

  mutations: {
    // 储存编辑中的数据
    saveEditDecorate(state, data) {
      state.editDecorate = data;
    },
  },

  actions: {},
};

export default decorate;
